export const SOLIDJS_STATIC_IMPORT_YAML = `project:
  name: recipe-solidjs
  tags:
    - zerops-recipe

services:
  - hostname: app
    type: static
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-solidjs-static`;
